module.exports = __webpack_public_path__ + "static/media/mp.03015f7a.webp";